import { c as _c } from "react/compiler-runtime";
import TuneIcon from '@mui/icons-material/Tune';
import type { SxProps } from '@mui/material';
export const Filter = t0 => {
  const $ = _c(2);
  const {
    sx
  } = t0;
  let t1;
  if ($[0] !== sx) {
    t1 = <TuneIcon sx={{
      ...sx
    }} />;
    $[0] = sx;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};